function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as chatroomActions from './../chatroomActions';

export var ImageUpload = function (_Component) {
    _inherits(ImageUpload, _Component);

    function ImageUpload(props) {
        _classCallCheck(this, ImageUpload);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleSubmit = function (file) {
            var _this$props = _this.props,
                dispatch = _this$props.dispatch,
                chatroomId = _this$props.chatroomId;

            var ImageServer = 'http://localhost:8080/';

            var span = document.createElement('span');
            span.textContent = "progression fichier : ";

            var progressBar = document.createElement('progress');
            progressBar.id = "progressBar";
            progressBar.value = 0;
            progressBar.max = 100;
            span.appendChild(progressBar);
            document.getElementById("message").appendChild(span);

            var data = new FormData();
            data.append('file', file);
            data.append('filename', file.name);

            fetch(ImageServer + 'api/photo', {
                method: 'POST',
                body: data
            }).then(function (response) {
                response.json().then(function (body) {

                    if (ImageServer + body.file !== ImageServer) {
                        dispatch(chatroomActions.sendMessage(chatroomId, ImageServer + body.file, 'img'));
                        _this.setState({ file: '', imagePreviewUrl: '' });
                    }
                });
            }).catch(function (error) {
                console.error('[CHATROOM]Image upload error : ', error);
            });
        };

        _this.state = {
            imagePreviewUrl: ''
        };

        return _this;
    }

    ImageUpload.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var file = this.props.file;


        var reader = new FileReader();

        reader.onloadend = function () {
            _this2.setState({
                imagePreviewUrl: reader.result
            });
        };

        if (file) {
            reader.readAsDataURL(file);
        }

        this.handleSubmit(file);
    };

    ImageUpload.prototype.render = function render() {
        var _this3 = this;

        var imagePreviewUrl = this.state.imagePreviewUrl;

        var $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = React.createElement('img', { src: imagePreviewUrl, alt: 'preview' });
        } else {
            $imagePreview = React.createElement('div', { className: 'previewText' });
        }
        var user = this.props.user;


        return React.createElement(
            'li',
            { className: 'chat right',
                ref: function ref(el) {
                    _this3.el = el;
                } },
            React.createElement('img', { className: 'profilpic', src: user.imageUrl, alt: user.username + '\'s profile pic' }),
            user.username,
            React.createElement('br', null),
            React.createElement(
                'div',
                { className: 'messages' },
                $imagePreview,
                React.createElement('div', { id: 'message' })
            )
        );
    };

    return ImageUpload;
}(Component);

function mapStateToProps(state) {
    return {
        file: state.chatroom.file,
        chatroomId: state.chatroom.chatroomId,
        chatroomUsers: state.chatroom.users,
        user: state.user
    };
}

export default connect(mapStateToProps)(ImageUpload);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/ImageUpload/ImageUpload.js
// module id = 224
// module chunks = 0